<template>
    <div class="about-page">
        <div class="about-page-bg-image-container" v-if="backgroundImage">
            <div :style="$pageBackgroundOverlay" class="about-page-background-image-overlay"></div>
            <div :style="{backgroundImage: 'url('+backgroundImage+')'}" class="about-page-background-image">
                <div :style="$pageBackgroundOverlay" class="about-page-background-image-gradient"></div>
            </div>
        </div>
        <div class="about-page-content">
            <div :style="$highlightColor" class="about-page-header-title" :class="backgroundImage ? 'about-page-header-title--with-background' : ''">
                {{page.header_title}}
            </div>

            <!-- Uncomment when social profiles is implemented -->

            <!-- <div class="about-page-social-profiles" v-if="page.social_profiles">
                 <span class="about-page-social-profile" v-for="(value, key) in dummy_social_profiles" :key="key">
                     <font-awesome-icon class="about-page-social-profile-icon" :icon="['fab',key]"></font-awesome-icon>
                 </span>
             </div>-->
            <div class="ql-editor" v-html="page.biography"></div>
        </div>
    </div>
</template>

<script>
    import Configure from './../../mixins/configure';
    import Page from './../../mixins/page.vue';

    export default {
        name: 'About',
        mixins: [Page, Configure],
        computed: {
            backgroundImage() {
                return (this.page.background_image && !this.page.background_image_upload) ? this.page.background_image : this.page.background_image_upload;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .about-page {
        padding: 0 1.5rem;

        .about-page-background-image {
            position: absolute;
            z-index: 0;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border: 0;
            background-repeat: no-repeat;
            background-position: center top;
            background-size: cover;
            opacity: 0.3;
        }

        .about-page-background-image-overlay {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 1
        }

        .about-page-background-image-gradient {
            position: absolute;
            bottom: 0;
            height: 65%;
            width: 100%;
            background-repeat: repeat-x;
        }

        .about-page-content {
            position: relative;
            z-index: 10;

            .about-page-header-title {
                font-weight: 700;
                font-size: 5rem;
                margin-bottom: 1rem;
                word-break: break-word;
                margin-top: 4rem;

                &--with-background {
                    margin-top: 6rem;
                }

                @media screen and (max-width: 588px) {
                    margin-top: 3rem;
                    font-size: 4rem;
                }

                @media screen and (max-width: 483px) {
                    margin-top: 2rem;
                    font-size: 2.5rem;
                }
            }

            .ql-editor {
                margin-top: 1rem;
                padding: 0;
                font-family: Poppins;
                overflow-y: unset;
            }
        }

        .about-page-social-profiles {
            display: flex;

            .about-page-social-profile {
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                align-content: center;
                background-color: rgb(135, 73, 157);
                color: white;
                border-radius: 50%;
                margin-right: 1rem;
                font-size: 15px;

                &-icon {
                    margin: auto;
                }
            }
        }

    }
</style>